import React from 'react'

import { CircularProgress } from '../../../../../shared/NarusMaterial'

import AdvancedDirective from './Forms/advancedDirective'
import DNR from './Forms/dnr'
import LivingWill from './Forms/livingWill'
import POST from './Forms/post'

class DocumentForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reRender: false
    }
  }

  componentDidMount () {
    this.setState({
      reRender: true
    })
  }

  renderDocument () {
    const { type, index, initialValues } = this.props
    switch (type) {
      case 'LW':
        return this.renderLW(initialValues, index)
      case 'DNR':
        return this.renderDNR(initialValues, index)
      case 'AD':
        return this.renderAD(initialValues, index)
      case 'PP':
        return this.renderPOST(initialValues, index)
      default:
        return null
    }
  }

  renderLW (document, index, documentIndex) {
    return (
      <LivingWill
        key={index}
        value={document}
        index={index}
        formIndex={documentIndex}
        formKey={`documentForm${index}`}
        handleSubmit={this.props.handleSubmit}
        cancel={this.props.cancel}
      />
    )
  }

  renderDNR (document, index, documentIndex) {
    return (
      <DNR
        key={index}
        value={document}
        index={index}
        formIndex={documentIndex}
        formKey={`documentForm${index}`}
        handleSubmit={this.props.handleSubmit}
        cancel={this.props.cancel}
      />
    )
  }

  renderAD (document, index, documentIndex) {
    return (
      <AdvancedDirective
        key={index}
        value={document}
        index={index}
        formIndex={documentIndex}
        formKey={`documentForm${index}`}
        handleSubmit={this.props.handleSubmit}
        cancel={this.props.cancel}
      />
    )
  }

  renderPOST (document, index, documentIndex) {
    return (
      <POST
        key={index}
        value={document}
        index={index}
        formIndex={documentIndex}
        formKey={`documentForm${index}`}
        handleSubmit={this.props.handleSubmit}
        cancel={this.props.cancel}
      />
    )
  }

  render () {
    if (!this.state.reRender) {
      return <CircularProgress />
    }
    return <div className='col-xs-12'>{this.renderDocument()}</div>
  }
}

export default DocumentForm
